import React from 'react'
import { Card, CardContent, Button, Radio } from '@/shared/ui'
import { getNavLayout, setNavLayout, type NavLayout } from '../services/navSettingsService'
import SaveFeedbackModal from '@/shared/ui/SaveFeedbackModal'
import { emitNavChanged } from '@/modules/navigation/events'

export default function NavLayoutSettings() {
  const [layout, setLayout] = React.useState<NavLayout>('sidebar')
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [saved, setSaved] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    let cancelled = false
    ;(async () => {
      setLoading(true); setError(null)
      try {
        const v = await getNavLayout('member')
        if (!cancelled) setLayout(v)
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Falha ao carregar')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [])

  async function onSave() {
    setSaving(true); setError(null)
    try {
      await setNavLayout('member', layout)
      setSaved(true)
    } catch (e: any) {
      setError(e?.message || 'Falha ao salvar')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <div className="text-sm font-medium">Layout de navegação (Membro)</div>
        <p className="text-sm text-foreground/70">Escolha se o menu do painel do membro aparece na lateral esquerda (padrão) ou no topo, com o mesmo estilo do cabeçalho da Home.</p>
        {error && <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}
        {loading ? (
          <div className="text-sm text-foreground/70">Carregando...</div>
        ) : (
          <div className="space-y-3">
            <div className="grid gap-2">
              <label className="flex items-center gap-2">
                <Radio name="navLayout" checked={layout==='sidebar'} onChange={()=> setLayout('sidebar')} />
                <span className="text-sm">Menu lateral (esquerda)</span>
              </label>
              <label className="flex items-center gap-2">
                <Radio name="navLayout" checked={layout==='header'} onChange={()=> setLayout('header')} />
                <span className="text-sm">Menu no topo (header da Home)</span>
              </label>
            </div>
            <div className="mt-3">
              <Button onClick={onSave} disabled={saving}>{saving ? 'Salvando...' : 'Salvar Preferência'}</Button>
            </div>
          </div>
        )}
        <SaveFeedbackModal open={saved} onClose={()=> { setSaved(false); emitNavChanged() }} title="Preferência salva" description="O layout de navegação do membro foi atualizado." />
      </CardContent>
    </Card>
  )
}

